import { useFlagsQuery } from '@cast/infrastructure-abilities';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

import { CAST_PILOT_ASSISTANT_ACK_FLAG } from './castPilotAssistant';

/**
 * Reads the in-house standalone flag that steers the OpsPilot acknowledgement
 * UX, scoped per organization via `targetingKey`. Mirrors `useIsOpsPilotEnabled`
 * — a direct flag read, not an ability gate.
 */
export const useOpsPilotAcknowledgementFlag = (): boolean => {
  const { currentOrganization } = useOrganizations();

  const { data } = useFlagsQuery({
    flagName: CAST_PILOT_ASSISTANT_ACK_FLAG,
    targetingKey: currentOrganization?.id,
    enabled: !!currentOrganization,
  });

  return data?.some((flag) => flag.boolean) ?? false;
};
